function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable camelcase */
import React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { node, object, string } from 'prop-types';
import SovosTypography from '../sovos-typography';
const StyledHeader = styled(SovosTypography)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.divider),
    boxSizing: 'border-box',
    color: palette.text.primary,
    display: 'flex',
    minHeight: spacing(4),
    lineHeight: 1,
    marginBlockEnd: "-".concat(spacing()),
    padding: "".concat(spacing(2), " ").concat(spacing(2), " ").concat(spacing(), " ").concat(spacing(2))
  };
});

/**
 * To define the header section of the card, encapsulate its content within
 * a `SovosCardHeader` component.
 *
 * **Note** Must be a child of `SovosCard`
 */
const SovosCardHeader = _ref2 => {
  let {
    children,
    classes,
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({
    classes: classes,
    className: clsx('sovosCardHeader', className),
    variant: "subtitle1"
  }, rest), children);
};
SovosCardHeader.propTypes = {
  /**
   * The content of the card header. `children` will be wrapped in a
   * `SovosTypography` component
   */

  children: node,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
export default SovosCardHeader;